import logoEmcali from '../../assets/img/eds.png'
import SliderLogin from '../../assets/img/cam-torre-emcali-01.png'
export const images = {
    logoEmcali,
    SliderLogin
}